import React, { memo, type ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Typography } from '@saviynt/design-system';
import cx from 'classnames';

import {
  AAG_SOD_DETAILS_WITH_ID,
  AAG_SOD_RECOMMENDATION_WITH_ID,
  AAG_SOD_REPORT,
  CF_NEU_BLD,
} from '../../../shared/constants';
import { useInvertedLocalize, useNavigateTo } from '../../../shared/hooks';
import { globalActions } from '../../../shared/store/actions';

import './ViolationsRole.css';

/**
 * * TODO
 * - Write a description
 */
function ViolationsRole(): ReactElement {
  const l = useInvertedLocalize();
  const dispatch = useDispatch();
  const { navigateToUrl } = useNavigateTo();

  // Demo setting global state to false after 1s
  useEffect(() => {
    setTimeout(() => {
      dispatch(globalActions.setIsGlobalLoading(false));
    }, 1000);
  }, [dispatch]);

  const timeSectionClasses = cx('Sod-ViolationsRole');

  return (
    <Box className={timeSectionClasses}>
      <section className='Sod-ViolationsRole-main'>
        <Box className='demo-toberemoved-testing-tabs'>
          <Typography kind='h1' color={CF_NEU_BLD}>
            {l(
              'This tab content is placeholder. Please take a look at more of these pages.'
            )}
          </Typography>
          <Button
            type='button'
            kind='filled'
            size='large'
            onClick={() => {
              navigateToUrl(AAG_SOD_RECOMMENDATION_WITH_ID);
            }}>
            {l('Go To Recommendations Page')}
          </Button>
          <Button
            type='button'
            kind='filled'
            size='large'
            onClick={() => navigateToUrl(AAG_SOD_REPORT)}>
            {l('Go To Report Page')}
          </Button>
          <Button
            type='button'
            kind='filled'
            size='large'
            onClick={() => {
              navigateToUrl(AAG_SOD_DETAILS_WITH_ID);
            }}>
            {l('Go To Details Page')}
          </Button>
          {l('Role')}
        </Box>
      </section>
    </Box>
  );
}

export default memo(ViolationsRole);
